var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "draggable",
    _vm._b(
      {
        staticClass: "v-gallery",
        class: { "v-gallery--has-any-selected": !!_vm.selected },
        attrs: { tag: "div" },
        on: {
          update: function($event) {
            _vm.$emit(
              "reorder-group",
              _vm.dataCollection.map(function(i) {
                return i.id
              }),
              _vm.galleryMemberId
            )
            _vm.$emit("reorder", _vm.reorder())
          }
        },
        model: {
          value: _vm.dataCollection,
          callback: function($$v) {
            _vm.dataCollection = $$v
          },
          expression: "dataCollection"
        }
      },
      "draggable",
      {
        group: "groups",
        draggable: _vm.isDraggable,
        delay: 400,
        delayOnTouchOnly: true,
        touchStartThreshold: 3,
        fallbackTolerance: 3,
        filter: _vm.selectorIsFiltered
      },
      false
    ),
    _vm._l(_vm.dataCollection, function(group) {
      return _c(
        "div",
        {
          key: group.id,
          staticClass: "v-gallery__group v-gallery__group-item"
        },
        [
          _c(
            "div",
            [
              _vm.toolbar
                ? _c(
                    "div",
                    { staticClass: "v-gallery__tools" },
                    [
                      _vm.addForm
                        ? _c(
                            "a",
                            {
                              staticClass: "add-facility",
                              staticStyle: { cursor: "pointer" },
                              attrs: { id: group.id },
                              on: {
                                click: function($event) {
                                  return _vm.toggleAddForm(group.id)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("add_circle_outline")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editButton
                        ? _c(
                            "a",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.toggleToolbar(group.id)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { "vertical-align": "top" },
                                attrs: { src: "/images/cms_wijzigen.png" }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.removeButton
                        ? _c(
                            "a",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit(
                                    "delete-group",
                                    group.id,
                                    _vm.galleryMemberId
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { "vertical-align": "top" },
                                attrs: { src: "/images/cms_verwijderen.png" }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("extra", null, { group: group })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t(
                "header",
                function() {
                  return [
                    _c("h3", { staticClass: "v-gallery__heading" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(group[_vm.groupName]) +
                          "\n        "
                      )
                    ])
                  ]
                },
                { group: group }
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.singleGallery && _vm.showLoaderFor === group.id
                ? _c("div", { staticClass: "loader-bar" })
                : _c("div", {
                    staticClass: "loader-bar loader-bar--loop",
                    staticStyle: { display: "none" }
                  }),
              _vm._v(" "),
              group.toolbar
                ? _c("div", [_vm._t("toolbar", null, { item: group })], 2)
                : _vm._e(),
              _vm._v(" "),
              _c(
                "draggable",
                _vm._b(
                  {
                    staticClass: "v-gallery__list",
                    attrs: { tag: "ul", draggable: _vm.selector },
                    on: {
                      update: function($event) {
                        _vm.$emit(
                          "reorder-item",
                          group[_vm.items].map(function(i) {
                            return i.id
                          }),
                          group.id,
                          _vm.galleryMemberId
                        )
                        _vm.$emit("reorder", _vm.reorder())
                      },
                      add: function($event) {
                        _vm.$emit(
                          "reorder-outer-item",
                          group[_vm.items].map(function(i) {
                            return i.id
                          }),
                          group.id,
                          _vm.galleryMemberId
                        )
                      },
                      change: function($event) {
                        $event.removed || $event.added
                          ? _vm.$emit(
                              "change",
                              $event,
                              group.id,
                              _vm.galleryMemberId
                            )
                          : null
                      }
                    },
                    model: {
                      value: group[_vm.items],
                      callback: function($$v) {
                        _vm.$set(group, _vm.items, $$v)
                      },
                      expression: "group[items]"
                    }
                  },
                  "draggable",
                  {
                    group: "items",
                    delay: 400,
                    delayOnTouchOnly: true,
                    touchStartThreshold: 3,
                    fallbackTolerance: 3
                  },
                  false
                ),
                [
                  _vm._l(group[_vm.items], function(item) {
                    return [
                      _c(
                        "li",
                        {
                          key: item.id,
                          staticClass:
                            "v-gallery__item v-gallery__item--draggable",
                          class: {
                            "v-gallery__item--is-selected":
                              _vm.selected === item
                          }
                        },
                        [
                          _c("div", { staticClass: "v-gallery__holder" }, [
                            _c(
                              "div",
                              { staticClass: "v-gallery__inner" },
                              [
                                _vm._t("default", null, {
                                  galleryId: _vm.galleryMemberId,
                                  item: item,
                                  group: group,
                                  groupheader: group[_vm.groupName],
                                  isSelected: _vm.selected === item
                                })
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-lightcase-holder", {
                            attrs: {
                              "image-src": item.url,
                              name: "lightcase-" + item.id,
                              "download-link": item.fileUrl,
                              "current-document": item,
                              "disable-rotate": _vm.disableRotate,
                              details: group
                            }
                          })
                        ],
                        1
                      )
                    ]
                  }),
                  _vm._v(" "),
                  !_vm.selected
                    ? _c(
                        "li",
                        {
                          staticClass:
                            "v-gallery__item v-gallery__item-to-drop",
                          attrs: { for: "file" + group.id },
                          on: {
                            dragover: function($event) {
                              return _vm.resetEvent($event)
                            },
                            dragleave: function($event) {
                              return _vm.resetEvent($event)
                            },
                            drop: function($event) {
                              return _vm.handleUpload(
                                $event,
                                group.id,
                                _vm.galleryMemberId
                              )
                            },
                            click: function($event) {
                              return _vm.triggerFileInputClick(
                                "fileInput" + group.id
                              )
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "v-gallery__holder" }, [
                            _c("div", { staticClass: "v-gallery__inner" }, [
                              _c("div", { staticClass: "v-gallery__plus" }, [
                                _vm._v("\n                +\n              ")
                              ])
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.acceptImages
                ? _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    ref: "fileInput" + group.id,
                    refInFor: true,
                    attrs: { type: "file", multiple: "", accept: "image/*" },
                    on: {
                      change: function($event) {
                        return _vm.handleUpload(
                          $event,
                          group.id,
                          _vm.galleryMemberId
                        )
                      }
                    }
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    ref: "fileInput" + group.id,
                    refInFor: true,
                    attrs: { type: "file", multiple: "" },
                    on: {
                      change: function($event) {
                        return _vm.handleUpload(
                          $event,
                          group.id,
                          _vm.galleryMemberId
                        )
                      }
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          group.addForm
            ? _c(
                "div",
                { staticStyle: { display: "flex" } },
                [_vm._t("add-form", null, { item: group })],
                2
              )
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cdd4b27", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdd4b27","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VGallery.vue
// module id = 308
// module chunks = 1 2